var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#267072",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3911_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5345 11.1973L8.71276 17.0195C8.68342 17.0488 8.66252 17.0856 8.65226 17.1258L8.00692 19.7158C7.99878 19.7496 7.99836 19.7847 8.0057 19.8187C8.01305 19.8526 8.02796 19.8845 8.04934 19.9118C8.07071 19.9392 8.09799 19.9614 8.12913 19.9767C8.16028 19.9921 8.19449 20.0002 8.22922 20.0005C8.24755 20.0005 8.26634 19.9982 8.28467 19.9936L10.8747 19.3483C10.915 19.3381 10.9517 19.3172 10.981 19.2878L16.8033 13.466L14.5345 11.1973ZM18.2456 10.4034L17.5975 9.75534C17.1644 9.32221 16.4095 9.32267 15.9769 9.75534L15.183 10.5492L17.4518 12.8179L18.2456 12.0241C18.462 11.8078 18.5811 11.5199 18.5811 11.2138C18.5811 10.9076 18.462 10.6198 18.2456 10.4034Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3911_284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/EditPen.faa228fc54237f47bce4fcae6a51f48c.svg";
export { ForwardRef as ReactComponent };